module.exports = __webpack_public_path__ + "img/qr-code.689282ba.png";